import * as actionTypes from "./actionTypes";

export const openLoadingPage = () => ({
	type: actionTypes.OPEN_LOADING_PAGE
});

export const closeLoadingPage = () => ({
	type: actionTypes.CLOSE_LOADING_PAGE
});

export const setAlertMessage = params => ({
	type: actionTypes.SET_ALERT_MESSAGE,
	params
});

export const setProductPrevious = params => ({
	type: actionTypes.SET_PRODUCT_PREVIOUS_ACTION,
	params
});

export const setMenuActive = params => ({
	type: actionTypes.SET_MENU_ACTIVE_ACTION,
	params
});

export const setDeleteProductprevious = params => ({
	type: actionTypes.SET_DELETE_PRODUCT_PREVIOUS_ACTION,
	params
});

export const setValueSearchProductAction = params => ({
	type: actionTypes.SET_VALUE_SEARCH_PRODUCT_ACTION,
	params
});

export const getValidateLoginFaceIdAction = () => ({
	type: actionTypes.GET_VALIDATE_LOGIN_FACE_ID_ACTION
});

export const setValidateLoginFaceIdAction = params => ({
	type: actionTypes.SET_VALIDATE_LOGIN_FACE_ID_ACTION,
	params
});

export const setMessageChangePassword = params => ({
	type: actionTypes.SET_MESSAGE_CHANGE_PASSWORD,
	params
});
